export const EMAIL_VERIFIED = 'EMAIL_VERIFIED';
export const EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED';
export const INVALID_ENTITY = 'INVALID_ENTITY';

export const EXPIRED_REFRESH_TOKEN = 'EXPIRED_REFRESH_TOKEN';
export const INVALID_VERIFICATION_CODE = 'INVALID_VERIFICATION_CODE';
export const CHANGE_EMAIL_REQUEST_REQUIRED = 'CHANGE_EMAIL_REQUEST_REQUIRED';
